const LabourSvg = ({ active }) => {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M12 15C9.33 15 4 16.34 4 19V21H20V19C20 16.34 14.67 15 12 15Z" fill={active ? 'white' : '#212121'} />
            <path
                d="M7.74 9H16.27C16.54 9 16.76 8.78 16.76 8.51V8.49C16.76 8.22 16.54 8 16.27 8H16C16 6.52 15.19 5.25 14 4.55V5.5C14 5.78 13.78 6 13.5 6C13.22 6 13 5.78 13 5.5V4.14C12.68 4.06 12.35 4 12 4C11.65 4 11.32 4.06 11 4.14V5.5C11 5.78 10.78 6 10.5 6C10.22 6 10 5.78 10 5.5V4.55C8.81 5.25 8 6.52 8 8H7.74C7.47 8 7.25 8.22 7.25 8.49V8.52C7.25 8.78 7.47 9 7.74 9Z"
                fill={active ? 'white' : '#212121'}
            />
            <path d="M12.0006 13C13.8606 13 15.4106 11.72 15.8606 10H8.14062C8.59062 11.72 10.1406 13 12.0006 13Z" fill={active ? 'white' : '#212121'} />
        </svg>
    );
};

export default LabourSvg;
